import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface ISiparisOlustur_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISiparisOlustur_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetLanguage: string;
  GetLanguage_dummy: string;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  SiparisSepetiMarkalari: any[];
  SiparisSepetiMarkalari_dummy: any[];
  GetSiparisSepeti: any[];
  GetSiparisSepeti_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  GetCariPlasiyerBilgileri: any[];
  GetCariPlasiyerBilgileri_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  SetValueOf: any;
  SetValueOf_dummy: any;
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  SiparisSepetMiktarUpdate: number;
  SiparisSepetMiktarUpdate_dummy: number;
  UrunMiktarAzalt: number;
  UrunMiktarAzalt_dummy: number;
  UrunMiktarArtir: number;
  UrunMiktarArtir_dummy: number;
  SiparisSepetiKalemSil: number;
  SiparisSepetiKalemSil_dummy: number;
  SepetHesapla: any[];
  SepetHesapla_dummy: any[];
  GetYeniSiparisNumarasi: any[];
  GetYeniSiparisNumarasi_dummy: any[];
  InsertSiparisMas: number;
  InsertSiparisMas_dummy: number;
  InsertSiparisTra: number;
  InsertSiparisTra_dummy: number;
  ForEach2: GetSiparisSepeti;
  ForEach2_dummy: GetSiparisSepeti;
  SiparisSonrasiSepetSil: number;
  SiparisSonrasiSepetSil_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  SendMail: boolean;
  SendMail_dummy: boolean;
  isComp501002Visible: "visible" | "hidden";
  isComp402891Visible: "visible" | "hidden";
  isComp457385Visible: "visible" | "hidden";
  isComp300785Visible: "visible" | "hidden";
  isComp851873Visible: "visible" | "hidden";
  isComp334646Visible: "visible" | "hidden";
  isComp185114Visible: "visible" | "hidden";
  isComp718258Visible: "visible" | "hidden";
  isComp159473Visible: "visible" | "hidden";
  isComp722702Visible: "visible" | "hidden";
  isComp245572Visible: "visible" | "hidden";
  isComp376522Visible: "visible" | "hidden";
  isComp325380Visible: "visible" | "hidden";
}

export class SiparisOlustur_ScreenBase extends React.PureComponent<
  ISiparisOlustur_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  siparisolustur_510693_value_kuikaFlexGridRef: React.RefObject<any>;
  siparisolustur_501002_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 781451,
          PropertyName: "label",
          Value: "CALCULATE CART",
          TagName: "Button2_label",
        },
        {
          Id: 622938,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 797289,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 652083,
          PropertyName: "value",
          Value: "CART DETAILS",
          TagName: "Label43_value",
        },
        {
          Id: 655780,
          PropertyName: "placeholder",
          Value: "ENTER REQUEST NUMBER",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "ENTER ORDER NUMBER",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 766999,
          PropertyName: "value",
          Value: "PAYMENT INFOS",
          TagName: "Label44_value",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "CREATE AN ORDER",
          TagName: "Button1_label",
        },
        {
          Id: 510693,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
          TagName: "FlexGrid1_nodatafoundmessage",
        },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORD TO VIEW",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 636561,
          PropertyName: "value",
          Value: "TOTAL AMOUNT",
          TagName: "Label19_value",
        },
        {
          Id: 987320,
          PropertyName: "value",
          Value: "DISCOUNT AMOUNT",
          TagName: "Label24_value",
        },
        {
          Id: 960022,
          PropertyName: "value",
          Value: "TAX",
          TagName: "Label22_value",
        },
        {
          Id: 452136,
          PropertyName: "value",
          Value: "GENERAL AMOUNT",
          TagName: "Label21_value",
        },
        {
          Id: 78227,
          PropertyName: "value",
          Value: "ORDER CART",
          TagName: "Label27_value",
        },
        {
          Id: 852138,
          PropertyName: "value",
          Value:
            "PLEASE RECHECK ERROR LINE FROM YOUR ORDER FILE AND RECREATE AGAIN",
          TagName: "Label39_value",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "PICTURE",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "CODE",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "NAME",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "BRAND",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 789733,
          PropertyName: "title",
          Value: "AMOUNT",
          TagName: "TableDefaultColumn1_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "Amount",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "GROSS AMOUNT",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 662203,
          PropertyName: "title",
          Value: "NET PRICE",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 885599,
          PropertyName: "title",
          Value: "NET AMOUNT",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 93867,
          PropertyName: "title",
          Value: "ACCOUNT USER",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 708758,
          PropertyName: "title",
          Value: "OTHER",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 828232,
          PropertyName: "value",
          Value: "/",
          TagName: "Label36_value",
        },
        {
          Id: 159473,
          PropertyName: "value",
          Value: "K",
          TagName: "Label37_value",
        },
        {
          Id: 722702,
          PropertyName: "value",
          Value: "P",
          TagName: "Label38_value",
        },
        {
          Id: 25804857,
          PropertyName: "8b852c28-8039-8ae4-7515-ce782675fa13_notify",
          Value:
            "ORDER SUCCESSFULLY CREATED. PLEASE CHECK FROM ORDER STATUS PAGE.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 781451,
          PropertyName: "label",
          Value: "Calculer le Panier",
          TagName: "Button2_label",
        },
        {
          Id: 622938,
          PropertyName: "placeholder",
          Value: "No Vaden, numéro OEM, nom du produit, modèle, véhicule",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 797289,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 652083,
          PropertyName: "value",
          Value: "Informations sur le panier",
          TagName: "Label43_value",
        },
        {
          Id: 655780,
          PropertyName: "placeholder",
          Value: "Entrez le numéro de demande",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "Entrez la note de commande",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 766999,
          PropertyName: "value",
          Value: "Informations de paiement",
          TagName: "Label44_value",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "Créer une commande",
          TagName: "Button1_label",
        },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun enregistrement à afficher",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 636561,
          PropertyName: "value",
          Value: "Montant total",
          TagName: "Label19_value",
        },
        {
          Id: 987320,
          PropertyName: "value",
          Value: "Remise",
          TagName: "Label24_value",
        },
        {
          Id: 960022,
          PropertyName: "value",
          Value: "TVA",
          TagName: "Label22_value",
        },
        {
          Id: 452136,
          PropertyName: "value",
          Value: "Total général",
          TagName: "Label21_value",
        },
        {
          Id: 78227,
          PropertyName: "value",
          Value: "Panier de la commande ",
          TagName: "Label27_value",
        },
        {
          Id: 852138,
          PropertyName: "value",
          Value:
            "Vous pouvez modifier les articles de votre commande et créer votre commande.",
          TagName: "Label39_value",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "Image",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "Code",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Nom",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Marque",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 789733,
          PropertyName: "title",
          Value: "Quantité",
          TagName: "TableDefaultColumn1_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Prix brut",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 662203,
          PropertyName: "title",
          Value: "Prix net",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 885599,
          PropertyName: "title",
          Value: "Montant net",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 93867,
          PropertyName: "title",
          Value: "Utilisateur",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 708758,
          PropertyName: "title",
          Value: "Autre",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 26751575,
          PropertyName: "8b852c28-8039-8ae4-7515-ce782675fa13_notify",
          Value:
            "Votre commande a été créée avec succès. Vous pouvez suivre votre commande depuis la page « État de la commande ».",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 781451,
          PropertyName: "label",
          Value: "Calcular carrito",
          TagName: "Button2_label",
        },
        {
          Id: 622938,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. oem, Nombre del producto, Marca, Modelo, Vehículo",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 797289,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 652083,
          PropertyName: "value",
          Value: "Información del carrito",
          TagName: "Label43_value",
        },
        {
          Id: 655780,
          PropertyName: "placeholder",
          Value: "Ingresar el No. de solicitud",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "Ingresar notas al pedido",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 766999,
          PropertyName: "value",
          Value: "Información del pago",
          TagName: "Label44_value",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "Crear pedido",
          TagName: "Button1_label",
        },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontraron registros para agregar",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 636561,
          PropertyName: "value",
          Value: "Valor total",
          TagName: "Label19_value",
        },
        {
          Id: 987320,
          PropertyName: "value",
          Value: "Descuento",
          TagName: "Label24_value",
        },
        {
          Id: 960022,
          PropertyName: "value",
          Value: "IVA",
          TagName: "Label22_value",
        },
        {
          Id: 452136,
          PropertyName: "value",
          Value: "Total general",
          TagName: "Label21_value",
        },
        {
          Id: 78227,
          PropertyName: "value",
          Value: "Carrito de pedidos",
          TagName: "Label27_value",
        },
        {
          Id: 852138,
          PropertyName: "value",
          Value: "Puede editar los artículos de su pedido y crear uno nuevo.",
          TagName: "Label39_value",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "Imagen",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "Código",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Nombre",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Marca",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 789733,
          PropertyName: "title",
          Value: "Importe",
          TagName: "TableDefaultColumn1_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Precio bruto",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 662203,
          PropertyName: "title",
          Value: "Precio neto",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 885599,
          PropertyName: "title",
          Value: "Valor neto",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 93867,
          PropertyName: "title",
          Value: "Usuario",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 708758,
          PropertyName: "title",
          Value: "Otro",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 31766429,
          PropertyName: "8b852c28-8039-8ae4-7515-ce782675fa13_notify",
          Value:
            "Pedido creado correctamente. Puede rastrear su pedido en la página de estado del pedido.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "f07a9c7f-1772-48a1-b6ff-05d250af20b3",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 622938,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 638103, PropertyName: "label", Value: "Turkish" },
        { Id: 987790, PropertyName: "label", Value: "English" },
        { Id: 589063, PropertyName: "label", Value: "Spanish" },
        { Id: 424767, PropertyName: "label", Value: "French" },
        { Id: 797289, PropertyName: "label", Value: "Profil" },
        { Id: 78227, PropertyName: "value", Value: "Sipariş Sepeti" },
        {
          Id: 852138,
          PropertyName: "value",
          Value:
            "Siparişiniz ile ilgili kalem düzenlemeleri yapıp sipariş oluşturabilirsiniz",
        },
        {
          Id: 510693,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 650893,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 127832, PropertyName: "placeholder", Value: "Type here..." },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 197987, PropertyName: "title", Value: "Resim" },
        { Id: 185114, PropertyName: "title", Value: "[datafield:aciklama]" },
        { Id: 501159, PropertyName: "title", Value: "Kod" },
        { Id: 455729, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 835743, PropertyName: "title", Value: "Adı" },
        { Id: 941477, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 687263, PropertyName: "title", Value: "Marka" },
        {
          Id: 342464,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 789733, PropertyName: "title", Value: "Miktar" },
        { Id: 541421, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 863752, PropertyName: "placeholder", Value: "15" },
        { Id: 280373, PropertyName: "title", Value: "Brut Fiyat" },
        {
          Id: 718258,
          PropertyName: "value",
          Value: "[datafield:kampanyasızbirimfiyat]",
        },
        { Id: 596796, PropertyName: "value", Value: "[datafield:birimfiat]" },
        { Id: 662203, PropertyName: "title", Value: "Net Fiyat" },
        { Id: 693476, PropertyName: "value", Value: "[datafield:netfiyat]" },
        { Id: 885599, PropertyName: "title", Value: "Net Tutar" },
        { Id: 115524, PropertyName: "value", Value: "[datafield:nettutar]" },
        { Id: 93867, PropertyName: "title", Value: "Kullanıcı" },
        { Id: 989713, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 828232, PropertyName: "value", Value: "/" },
        { Id: 159473, PropertyName: "value", Value: "K" },
        { Id: 722702, PropertyName: "value", Value: "P" },
        { Id: 708758, PropertyName: "title", Value: "Diğer" },
        { Id: 781451, PropertyName: "label", Value: "Sepet Hesapla" },
        { Id: 652083, PropertyName: "value", Value: "Sepet Bilgileri" },
        { Id: 655780, PropertyName: "placeholder", Value: "Talep No Giriniz" },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "Sipariş Notu Giriniz",
        },
        { Id: 766999, PropertyName: "value", Value: "Ödeme Bilgileri" },
        { Id: 636561, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 987320, PropertyName: "value", Value: "İskonto" },
        { Id: 646441, PropertyName: "value", Value: "Net Tutar" },
        { Id: 960022, PropertyName: "value", Value: "Kdv" },
        { Id: 452136, PropertyName: "value", Value: "Genel Toplam" },
        { Id: 838301, PropertyName: "label", Value: "Sipariş Oluştur" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach2: any[];

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.siparisolustur_622938_value_kuikaTextInputRef = React.createRef();
    this.siparisolustur_510693_value_kuikaFlexGridRef = React.createRef();
    this.siparisolustur_127832_value_kuikaTextInputRef = React.createRef();
    this.siparisolustur_501002_value_kuikaTableRef = React.createRef();
    this.siparisolustur_655780_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetLanguage: "",
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetParametreler: [],
      SiparisSepetiMarkalari: [],
      GetSiparisSepeti: [],
      GetCariParaBirimi: [],
      GetCariPlasiyerBilgileri: [],
      IfThenElse: false,
      ChangeVisibilityOf: "",
      TriggerEvent: "",
      SiparisSepetMiktarUpdate: 0,
      UrunMiktarAzalt: 0,
      UrunMiktarArtir: 0,
      SiparisSepetiKalemSil: 0,
      SepetHesapla: [],
      GetYeniSiparisNumarasi: [],
      InsertSiparisMas: 0,
      ForEach: false,
      SiparisSonrasiSepetSil: 0,
      Notify: false,
      isComp501002Visible: "hidden",
      isComp402891Visible: "hidden",
      isComp457385Visible: "hidden",
      isComp300785Visible: "hidden",
      isComp851873Visible: "hidden",
      isComp334646Visible: "hidden",
      isComp185114Visible: "hidden",
      isComp718258Visible: "hidden",
      isComp159473Visible: "hidden",
      isComp722702Visible: "hidden",
      isComp245572Visible: "hidden",
      isComp376522Visible: "hidden",
      isComp325380Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "siparisolustur",
        "blank_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.SiparisOlusturPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.SiparisOlusturPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("siparisolustur", "blank_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("siparisolustur", "blank_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SiparisOlusturPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.SiparisOlusturPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  SiparisOlusturPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisOlusturPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.siparisolustur_943353_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisOlusturPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      secilenMarka_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Carikodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      kulID_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      cariKod_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      musteriMarka_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      paraBirimi_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      SessionCariKod_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      gykPlasiyerKodu_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      CariPlasiyerKodu_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].plasiyeR_KODU
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].plasiyeR_KODU
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.siparisolustur_757874_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.siparisolustur_82433_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp457385Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.SiparisSepetiMarkalari = result?.data.siparisSepetiMarkalari;

    stateVars.GetSiparisSepeti = result?.data.getSiparisSepeti;

    stateVars.isComp376522Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSiparisSepeti !== undefined
            ? stateVars.GetSiparisSepeti?.length > 0
              ? stateVars.GetSiparisSepeti[0].id
              : null
            : this.state.GetSiparisSepeti?.length > 0
            ? this.state.GetSiparisSepeti[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    formVars.siparisolustur_82493_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.siparisolustur_920510_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.siparisolustur_637739_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.siparisolustur_28120_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.siparisolustur_63638_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    stateVars.GetCariPlasiyerBilgileri = result?.data.getCariPlasiyerBilgileri;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturPageInit_if4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.SiparisOlusturComponent_93784_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SiparisOlusturPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.SiparisSepetiMarkalari !== undefined
            ? stateVars.SiparisSepetiMarkalari?.length > 0
              ? stateVars.SiparisSepetiMarkalari[0].toplamKayitSayisi
              : null
            : this.state.SiparisSepetiMarkalari?.length > 0
            ? this.state.SiparisSepetiMarkalari[0].toplamKayitSayisi
            : null
        ),
        "1"
      )
    ) {
      isErrorOccurred = await this.SiparisOlusturPageInit_if4();
      if (isErrorOccurred) return true;
    } else {
    }

    formVars.siparisolustur_757874_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp457385Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisolustur_82433_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.siparisolustur_943353_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.siparisolustur_161436_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    stateVars.dataSource_510693 =
      stateVars.SiparisSepetiMarkalari ?? this.state.SiparisSepetiMarkalari;
    stateVars.isComp300785Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisolustur_510693_value",
          "isaktif"
        ),
        "true"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp851873Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisolustur_510693_value",
          "isaktif"
        ),
        "false"
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_501002 =
      stateVars.GetSiparisSepeti ?? this.state.GetSiparisSepeti;
    stateVars.isComp185114Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisolustur_501002_value",
          "varMi"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisolustur_457575_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp718258Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(this, "siparisolustur_501002_value", "renk"),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisolustur_33082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.siparisolustur_468484_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp159473Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisolustur_501002_value",
          "plasiyerMi"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp722702Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisolustur_501002_value",
          "plasiyerMi"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp376522Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSiparisSepeti !== undefined
            ? stateVars.GetSiparisSepeti?.length > 0
              ? stateVars.GetSiparisSepeti[0].id
              : null
            : this.state.GetSiparisSepeti?.length > 0
            ? this.state.GetSiparisSepeti[0].id
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisolustur_82493_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.siparisolustur_920510_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.siparisolustur_637739_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp325380Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].kdvTutar
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].kdvTutar
            : null
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisolustur_28120_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.siparisolustur_63638_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SiparisOlusturComponent_622938_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_622938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisOlustur",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_457385_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisOlustur",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_459492_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisOlustur",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "209051",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_638103_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_987790_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_589063_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_424767_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_797289_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisOlustur",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_93784_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "siparisolustur_127832_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.SiparisSepetiMarkalari !== undefined
          ? stateVars.SiparisSepetiMarkalari?.length > 0
            ? stateVars.SiparisSepetiMarkalari[0].musteriMarka
            : null
          : this.state.SiparisSepetiMarkalari?.length > 0
          ? this.state.SiparisSepetiMarkalari[0].musteriMarka
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_93784_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "siparisolustur_127832_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        "siparisolustur_510693_value",
        "musteriMarka"
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_93784_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.SiparisSepetiMarkalari !== undefined
            ? stateVars.SiparisSepetiMarkalari?.length > 0
              ? stateVars.SiparisSepetiMarkalari[0].toplamKayitSayisi
              : null
            : this.state.SiparisSepetiMarkalari?.length > 0
            ? this.state.SiparisSepetiMarkalari[0].toplamKayitSayisi
            : null
        ),
        "1"
      )
    ) {
      isErrorOccurred = await this.SiparisOlusturComponent_93784_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.SiparisOlusturComponent_93784_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_93784_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisOlusturComponent_93784_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      secilenMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Carikodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_93784_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetiMarkalari = result?.data.siparisSepetiMarkalari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_93784_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_93784_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp501002Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_93784_onClick3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisOlusturComponent_93784_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      kulID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      cariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      musteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_93784_onClick3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSiparisSepeti = result?.data.getSiparisSepeti;

    stateVars.isComp376522Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSiparisSepeti !== undefined
            ? stateVars.GetSiparisSepeti?.length > 0
              ? stateVars.GetSiparisSepeti[0].id
              : null
            : this.state.GetSiparisSepeti?.length > 0
            ? this.state.GetSiparisSepeti[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_93784_onClick4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_93784_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.SiparisOlusturComponent_781451_onClick()) return true;

    stateVars.dataSource_510693 =
      stateVars.SiparisSepetiMarkalari ?? this.state.SiparisSepetiMarkalari;

    stateVars.dataSource_501002 =
      stateVars.GetSiparisSepeti ?? this.state.GetSiparisSepeti;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_501002_onRowEditFinished = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_501002_miktar",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "siparisolustur_501002_value", ".id"),
        "number"
      ),
      kulID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      musteriMarka_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_501002_onRowEditFinished",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetMiktarUpdate = result?.data.siparisSepetMiktarUpdate;
    stateVars.GetSiparisSepeti = result?.data.getSiparisSepeti;

    stateVars.isComp376522Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSiparisSepeti !== undefined
            ? stateVars.GetSiparisSepeti?.length > 0
              ? stateVars.GetSiparisSepeti[0].id
              : null
            : this.state.GetSiparisSepeti?.length > 0
            ? this.state.GetSiparisSepeti[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SiparisOlusturComponent_501002_onRowEditFinished1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_501002_onRowEditFinished1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.SiparisOlusturComponent_781451_onClick()) return true;

    stateVars.dataSource_501002 =
      stateVars.GetSiparisSepeti ?? this.state.GetSiparisSepeti;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_23239_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Resimler",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisolustur_501002_value",
          "stokKodu"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisOlustur",
      "Resimler",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "339419",
      null,
      null,
      "true",
      "600px",
      "600px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_37988_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "siparisolustur_501002_value", "id"),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_37988_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UrunMiktarAzalt = result?.data.urunMiktarAzalt;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_37988_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_37988_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.SiparisOlusturPageInit();

    if (await this.SiparisOlusturComponent_781451_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_310448_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "siparisolustur_501002_value", "id"),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_310448_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UrunMiktarArtir = result?.data.urunMiktarArtir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_310448_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_310448_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.SiparisOlusturPageInit();

    if (await this.SiparisOlusturComponent_781451_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_387479_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "siparisolustur_501002_value", "id"),
        "number"
      ),
      secilenMarka_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Carikodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_387479_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetiKalemSil = result?.data.siparisSepetiKalemSil;
    stateVars.SiparisSepetiMarkalari = result?.data.siparisSepetiMarkalari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_387479_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_387479_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "siparisolustur_127832_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.SiparisSepetiMarkalari !== undefined
          ? stateVars.SiparisSepetiMarkalari?.length > 0
            ? stateVars.SiparisSepetiMarkalari[0].musteriMarka
            : null
          : this.state.SiparisSepetiMarkalari?.length > 0
          ? this.state.SiparisSepetiMarkalari[0].musteriMarka
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_387479_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "siparisolustur_127832_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp501002Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_387479_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.SiparisSepetiMarkalari !== undefined
            ? stateVars.SiparisSepetiMarkalari?.length > 0
              ? stateVars.SiparisSepetiMarkalari[0].toplamKayitSayisi
              : null
            : this.state.SiparisSepetiMarkalari?.length > 0
            ? this.state.SiparisSepetiMarkalari[0].toplamKayitSayisi
            : null
        ),
        "1"
      )
    ) {
      isErrorOccurred = await this.SiparisOlusturComponent_387479_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.SiparisOlusturComponent_387479_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_387479_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisOlusturComponent_387479_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      kulID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      cariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      musteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_387479_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSiparisSepeti = result?.data.getSiparisSepeti;

    stateVars.isComp376522Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSiparisSepeti !== undefined
            ? stateVars.GetSiparisSepeti?.length > 0
              ? stateVars.GetSiparisSepeti[0].id
              : null
            : this.state.GetSiparisSepeti?.length > 0
            ? this.state.GetSiparisSepeti[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.siparisolustur_82433_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_387479_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_387479_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.SiparisOlusturComponent_781451_onClick()) return true;

    formVars.siparisolustur_82433_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    stateVars.dataSource_510693 =
      stateVars.SiparisSepetiMarkalari ?? this.state.SiparisSepetiMarkalari;

    stateVars.dataSource_501002 =
      stateVars.GetSiparisSepeti ?? this.state.GetSiparisSepeti;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_207928_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "KalemNot",
      "KalemNot",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisolustur_501002_value",
          "kalemNot"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KalemNot",
      "id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "siparisolustur_501002_value", "id"),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisOlustur",
      "KalemNot",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "124528",
      null,
      null,
      "true",
      "500px",
      "55vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_781451_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      kulID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      carikod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_781451_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SepetHesapla = result?.data.sepetHesapla;
    formVars.siparisolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamTutar
        : null
    );
    formVars.siparisolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamIskontoTutar
        : null
    );
    formVars.siparisolustur_109546_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].netTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].netTutar
        : null
    );
    formVars.siparisolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].kdvTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].kdvTutar
        : null
    );
    formVars.siparisolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].genelToplam
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].genelToplam
        : null
    );
    stateVars.isComp325380Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].kdvTutar
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_781451_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_781451_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp402891Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    formVars.siparisolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamTutar
        : null
    );

    formVars.siparisolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamIskontoTutar
        : null
    );

    formVars.siparisolustur_109546_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].netTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].netTutar
        : null
    );

    formVars.siparisolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].kdvTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].kdvTutar
        : null
    );

    formVars.siparisolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].genelToplam
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisOlusturComponent_838301_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      kulID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      carikod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      GenelToplam_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].genelToplam
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].genelToplam
            : null
        ),
        "number"
      ),
      IskontoToplami_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].toplamIskontoTutar
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].toplamIskontoTutar
            : null
        ),
        "number"
      ),
      KdvTutari_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].kdvTutar
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].kdvTutar
            : null
        ),
        "number"
      ),
      KullaniciID_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      NetTutar_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].netTutar
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].netTutar
            : null
        ),
        "number"
      ),
      ParaBirimi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariParaBirimi !== undefined
            ? stateVars.GetCariParaBirimi?.length > 0
              ? stateVars.GetCariParaBirimi[0].tip
              : null
            : this.state.GetCariParaBirimi?.length > 0
            ? this.state.GetCariParaBirimi[0].tip
            : null
        ),
        "number"
      ),
      SiparisDurum_2: ReactSystemFunctions.convertToTypeByName(0, "number"),
      SiparisNot_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_451268_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SIPNO_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetYeniSiparisNumarasi !== undefined
            ? stateVars.GetYeniSiparisNumarasi?.length > 0
              ? stateVars.GetYeniSiparisNumarasi[0].yeniSiparisNumarasi
              : null
            : this.state.GetYeniSiparisNumarasi?.length > 0
            ? this.state.GetYeniSiparisNumarasi[0].yeniSiparisNumarasi
            : null
        ),
        "string"
      ),
      SiparisTarihi_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      TalepNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_655780_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ToplamTutar_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].toplamTutar
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].toplamTutar
            : null
        ),
        "number"
      ),
      PlasiyerKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].plasiyeR_KODU
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].plasiyeR_KODU
            : null
        ),
        "string"
      ),
      GenelIsk1_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].faturaAltiIskontoOrani
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].faturaAltiIskontoOrani
            : null
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_838301_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SepetHesapla = result?.data.sepetHesapla;
    formVars.siparisolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamTutar
        : null
    );
    formVars.siparisolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamIskontoTutar
        : null
    );
    formVars.siparisolustur_109546_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].netTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].netTutar
        : null
    );
    formVars.siparisolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].kdvTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].kdvTutar
        : null
    );
    formVars.siparisolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].genelToplam
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].genelToplam
        : null
    );
    stateVars.isComp325380Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.SepetHesapla !== undefined
            ? stateVars.SepetHesapla?.length > 0
              ? stateVars.SepetHesapla[0].kdvTutar
              : null
            : this.state.SepetHesapla?.length > 0
            ? this.state.SepetHesapla[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetYeniSiparisNumarasi = result?.data.getYeniSiparisNumarasi;
    stateVars.InsertSiparisMas = result?.data.insertSiparisMas;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_838301_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_838301_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.birimFiat),
        "number"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.miktar),
        "number"
      ),
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetYeniSiparisNumarasi !== undefined
            ? stateVars.GetYeniSiparisNumarasi?.length > 0
              ? stateVars.GetYeniSiparisNumarasi[0].yeniSiparisNumarasi
              : null
            : this.state.GetYeniSiparisNumarasi?.length > 0
            ? this.state.GetYeniSiparisNumarasi[0].yeniSiparisNumarasi
            : null
        ),
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.stokAdi),
        "string"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.stokKodu),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.musteriMarka),
        "string"
      ),
      NetFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.netFiyat),
        "number"
      ),
      NetTutar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.netTutar),
        "number"
      ),
      IskontoOrani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.iskontoOranlari),
        "string"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.kdvOrani),
        "number"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.excelKod),
        "string"
      ),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.excelNot1),
        "string"
      ),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.excelNot2),
        "string"
      ),
      KalemNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach2?.kalemNot),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_838301_onClick_foreach1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InsertSiparisTra = result?.data.insertSiparisTra;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SiparisOlusturComponent_838301_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.GetSiparisSepeti)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetSiparisSepeti
      )) {
        this.ForEach2 = item;
        await this.SiparisOlusturComponent_838301_onClick_foreach1();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_838301_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisOlusturComponent_838301_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      musteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisolustur_127832_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_838301_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSonrasiSepetSil = result?.data.siparisSonrasiSepetSil;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_838301_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisOlusturComponent_838301_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.SiparisOlusturPageInit();

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8b852c28_8039_8ae4_7515_ce782675fa13_notify",
        this.defaultML,
        "Sipariş Başarıyla Oluşturuldu. Sipariş Durumu Sayfasından Siparişinizi Takip Edebilirsiniz."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      10,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisOlusturComponent_838301_onClick4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisOlusturComponent_838301_onClick_if4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "76146948-69d9-4d83-8132-9929b28f7adb",
          "string"
        ),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariPlasiyerBilgileri !== undefined
            ? stateVars.GetCariPlasiyerBilgileri?.length > 0
              ? stateVars.GetCariPlasiyerBilgileri[0].kullaniciKodu
              : null
            : this.state.GetCariPlasiyerBilgileri?.length > 0
            ? this.state.GetCariPlasiyerBilgileri[0].kullaniciKodu
            : null
        ),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Yeni Sipariş", "string"),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "string"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetYeniSiparisNumarasi !== undefined
            ? stateVars.GetYeniSiparisNumarasi?.length > 0
              ? stateVars.GetYeniSiparisNumarasi[0].yeniSiparisNumarasi
              : null
            : this.state.GetYeniSiparisNumarasi?.length > 0
            ? this.state.GetYeniSiparisNumarasi[0].yeniSiparisNumarasi
            : null
        ),
        "string"
      ),
      KullaniciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].adSoyad
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].adSoyad
            : null
        ),
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_ISIM
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_ISIM
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisOlustur/SiparisOlusturComponent_838301_onClick_if4",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  SiparisOlusturComponent_838301_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        true
      )
    ) {
      isErrorOccurred = await this.SiparisOlusturComponent_838301_onClick_if4();
      if (isErrorOccurred) return true;
    } else {
    }

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/siparisdurumlari") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.SiparisOlusturComponent_838301_onClick5_,
      "SiparisOlustur",
      "SiparisDurumlari",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  SiparisOlusturComponent_838301_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.siparisolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamTutar
        : null
    );

    formVars.siparisolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].toplamIskontoTutar
        : null
    );

    formVars.siparisolustur_109546_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].netTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].netTutar
        : null
    );

    formVars.siparisolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].kdvTutar
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].kdvTutar
        : null
    );

    formVars.siparisolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.SepetHesapla !== undefined
        ? stateVars.SepetHesapla?.length > 0
          ? stateVars.SepetHesapla[0].genelToplam
          : null
        : this.state.SepetHesapla?.length > 0
        ? this.state.SepetHesapla[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 209051, , 339419, 124528] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SiparisOlusturPageInit();
    }
  }
}
